import {z} from 'zod'

export const emptyStringToNull = (arg: any) => {
    return z.preprocess(
        val => {
            if (typeof val !== 'string') {
                return val
            }
            return val.trim() || null
        },
        arg.nullable()
    ).optional()
}

const isNullish = (value: any) => value === null || value === undefined || value === ''

export const nullFieldsToNull = (obj: any) => {
    if(!obj) return obj
    const everyFieldIsNullish = Object.values(obj).every(isNullish)
    return everyFieldIsNullish ? null : obj
}